/** Declarations for the ::after that draws the hand-drawn underline. */
export const handLineAfter = `
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -0.02em;
  height: 6px;
  background-color: currentColor;
  -webkit-mask: var(--hand-line) repeat-x 0 0 / 240px 6px;
  mask: var(--hand-line) repeat-x 0 0 / 240px 6px;
  opacity: 0.3;
  transform-origin: center bottom;
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1), transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
`;
